"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationType = void 0;
var NotificationType;
(function (NotificationType) {
    NotificationType["ORDER_COMMENTED"] = "orderCommented";
    NotificationType["ORDER_UPDATED"] = "orderUpdated";
    NotificationType["ORDER_DELETED"] = "orderDeleted";
    NotificationType["EMAIL_RECEIVED"] = "emailReceived";
    NotificationType["CLIENT_REGISTERED"] = "clientRegistered";
})(NotificationType || (exports.NotificationType = NotificationType = {}));
